module.exports = __webpack_public_path__ + "static/media/Nissan-Ariya.e64939ea.jpg";